import { render, staticRenderFns } from "./hqglCanteenFeeDetail.vue?vue&type=template&id=2b8e159b&scoped=true&"
import script from "./hqglCanteenFeeDetail.vue?vue&type=script&lang=js&"
export * from "./hqglCanteenFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglCanteenFeeDetail.vue?vue&type=style&index=0&id=2b8e159b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e159b",
  null
  
)

export default component.exports